import {connect} from 'react-redux';
import CaptainEntryOptions from './CaptainEntryOptions.jsx';
import {
  handleChangeEntriesCaptainClick
} from './actions';

const mapStateToProps = state => ({ 
  changeMultipleEntriesErrors: state.admin.captainDetail.changeMultipleEntriesErrors,
  hasSelectedVirtualEntries:   state.admin.captainDetail.hasSelectedVirtualEntries,
  hasSelectedEntries: state.admin.captainDetail.hasSelectedEntries
});

const mapDispatchToProps = dispatch => ({
  onChangeEntriesCaptainClick: () => dispatch(handleChangeEntriesCaptainClick()) 
});

export default connect(mapStateToProps, mapDispatchToProps)(CaptainEntryOptions);



// WEBPACK FOOTER //
// ./src/features/admin/captainDetail/CaptainEntryOptionsContainer.jsx